<template>
  <s-page-block>
    <s-page-header :heading="t('page.heading', {institution: institution.abbreviation})" />

    <s-form-inline
      id="searchText"
      icon="magnify"
      class="mt-5 mb-4"
      :placeholder="t('search.placeholder')"
      :submitLabel="$t('search.label')"
      v-model="search"
    />

    <s-data-table
      :data="filteredUsers"
      :columns="[
        {key: 'firstName', label: t('firstName')},
        {key: 'lastName', label: t('lastName')},
        {key: 'email', label: t('email')},
      ]"
    />
  </s-page-block>
</template>

<script setup lang="ts">
import SPageBlock from '../../design-system/SPageBlock.vue';
import SPageHeader from '../../design-system/SPageHeader.vue';
import {Institution} from '../../types/entities/institution';
import {useI18n} from 'vue-i18n';
import {ref, computed} from 'vue';
import SFormInline from '../../design-system/SFormInline.vue';
import {User} from '../../types/entities/user';
import SDataTable from '../../design-system/SDataTable.vue';

const {users} = defineProps<{
  institution: Institution;
  users: User[];
  can: {
    create: boolean;
  };
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const search = ref<string>('');

const filteredUsers = computed(() => {
  return users.filter(
    (user) =>
      user.firstName.toLowerCase().includes(search.value.toLowerCase()) ||
      user.lastName.toLowerCase().includes(search.value.toLowerCase()) ||
      user.email.toLowerCase().includes(search.value.toLowerCase())
  );
});
</script>
<i18n>
{
  "en": {
    "page.heading": "{institution} Staff Members"
  },
  "fr": {
    "page.heading": "Membres du personnel de {institution}"
  }
}
</i18n>
